import { useEffect, useState } from "react";
import { filterEntities, getAllData } from "../../../apis/apiService";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  useFetchTimeLogActivitiesQuery,
  useFetchTimerActivitiesQuery,
} from "../../../slice/logdetailSlice";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { extractTextFromHTML } from "../../../utils/textUtils";
import Loader from "../../common/Loader";
import { format } from "date-fns";

const TimesheetActivity = ({ timesheet_details }) => {
  const { id } = useParams();
  // console.log("show_details id timer_id :", id);
  const [showActivity, setShowActivity] = useState([]);
  const {
    data: timer_activities,
    isLoading: timer_activity_loading,
    refetch: timer_refetch,  
  } = useFetchTimerActivitiesQuery(id);

  useEffect(() => {
      timer_refetch();
  }, [id]);

  const borderColors = ["#2196f3", "#4caf50", "#ff9800"];

  return (
    <Box className="border rounded my-3 py-3 showActivities">
      {timer_activity_loading ? (
        <Loader />

      ) : timer_activities?.length === 0 ? (
        <Typography className="text-center text-muted" sx={{ py: 4 }}>
          No Activity Found
        </Typography>
      ) : (
        timer_activities?.[0]?.events?.map((activity, index) => {
          const formatted = activity.time ? new Date(activity.time) : null;
          const formattedTime = formatted
            ? format(formatted, "hh:mm a")
            : "Invalid Time";
          const formattedDate = formatted
            ? format(formatted, "dd/MM/yyyy")
            : "Invalid Date";
          const displayType =
            {
              STARTED: "Started",
              STOPPED: "Stopped",
              PAUSED: "Paused",
              RESUMED: "Resumed",
            }[activity.type] || activity.type;
          const textNotes = activity.note
            ? extractTextFromHTML(activity.note)
            : "";
          return (
            <Box key={index} className="row" mb={3}>
              <Box className="col-md-3" textAlign="right">
              
              </Box>
              <Box
                className="col-md-9"
                sx={{
                  borderLeft: `4px solid ${
                    borderColors[index % borderColors.length]
                  }`,
                  paddingLeft: 2,
                }}
              >
                <Typography variant="body2" className="text-rgba-gray">
                  {displayType}
                </Typography>

                <Typography variant="body2" fontWeight="bold">
                  {formattedTime}, {formattedDate}
                </Typography>
                
                <Typography variant="body2" fontWeight="bold">
                  {textNotes}
                </Typography>
              </Box>
            </Box>
          );
        })
      )}
    </Box>
  );
};

export default TimesheetActivity;

export const TimerActivityStream = () => {
  const { id } = useParams();
  // const [showActivity, setShowActivity] = useState([]);
  const { data: task_activity_status, isLoading } =
    useFetchTimeLogActivitiesQuery(id);
  // console.log("useFetchTimeLogActivitiesQuery :", task_activity_status);

  const borderColors = ["#2196f3", "#4caf50", "#ff9800"]; // Blue, Green, Orange

  return (
    <Box className="border  rounded my-3 py-3 showActivities ">
      {task_activity_status?.map((activity, index) => {
        const [date, time] = activity.added_at.split(" ");
        // //console.log()("activitytest :", activity.added_at);

        return (
          <Box key={index} className="row" mb={3}>
            <Box className="col-md-3" textAlign="right">
              <Typography variant="body2" fontWeight="bold">
                {date}
              </Typography>
              <Typography variant="body2" className="text-rgba-gray">
                {time}
              </Typography>
            </Box>
            <Box
              className="col-md-9"
              sx={{
                borderLeft: `4px solid ${
                  borderColors[index % borderColors.length]
                }`, // Highlighted border on the left
                paddingLeft: 2,
                // borderRadius: 1,
                // backgroundColor: index % 2 === 0 ? 'rgba(0,0,0,0.04)' : 'transparent', // Optional background for alternate rows
              }}
            >
              <Box ml={2}>
                {activity.comments.split(",").map((update, idx) => (
                  <Typography
                    sx={{ mt: 1.5 }}
                    key={idx}
                    variant="body2"
                    fontWeight="bold"
                  >
                    {extractTextFromHTML(update)}
                  </Typography>
                ))}
              </Box>
              {/* )} */}
            </Box>
            {/* {index < activities.length - 1 && <Divider className="w-100" />} */}
          </Box>
        );
      })}
    </Box>
  );
};
